import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useNavItems } from '@/component/layout/SideNav/navItems.ts'

export interface ICrumb {
    label: string
    href?: string
}

/** 메뉴 이름 › 아래 화면. 앞 칸은 그 메뉴로 가는 링크, 마지막 칸이 지금 화면 */
export const usePageCrumbs = (): ICrumb[] => {
    const { t } = useTranslation()
    const { pathname } = useLocation()
    const navItems = useNavItems()

    return useMemo<ICrumb[]>(() => {
        if (pathname === '/account') return [{ label: t('topNav.menu.account') }]
        const item = navItems.find(navItem => {
            const navPath = navItem.href.split('?')[0]
            return pathname === navPath || pathname.startsWith(`${navPath}/`)
        })
        if (!item) return [{ label: t('app.title.carearly') }]
        if (pathname === item.href.split('?')[0]) return [{ label: item.label }]

        let current = ''
        if (pathname.startsWith('/user/')) current = t('topNav.crumb.userDetail')
        else if (pathname === '/mental-health/reports') current = t('topNav.crumb.reports')
        else if (pathname.startsWith('/mental-health/')) current = t('topNav.crumb.reportDetail')
        return current ? [{ label: item.label, href: item.href }, { label: current }] : [{ label: item.label }]
    }, [navItems, pathname, t])
}
